<!--
  AI:
  Status: 'in progress'
  Type: Component
  SubType: Shared OBC content
  Reason: Content of the read-only bank account overview (cr.CustomerBankAccount, TM-1000002030): the
          „Basisdaten“ data widget on top, the „Abrechnungskonten“ QL table below - in both variants.

  STATES: skeleton until the widgets are built; an info message without a usable bank account id; otherwise
  the two widgets, which bring their own loading, empty („Von keinem Abrechnungskonto verwendet.“) and error
  states. A missing bm read right fails only the table; the base data stay visible.

  READ-ONLY: `[disableUpdate]="true"` on BOTH widgets (FD-3 / S-2).

  DRAWER CONTRACT (compact = side view, readable at 40 % drawer width): the table block gets its OWN
  horizontal overflow container, so a row that is still too wide scrolls inside the drawer instead of pushing
  it sideways. In the full view the width belongs to the page.

  STATUS TAG: colour ONLY through `[styleClass]` with PrimeFlex tokens - never `[severity]` (the global
  `.p-tag` override wins over it) and never an inline colour (the tokens are !important) - AU-6.

  @ticket TM-1000002030
-->
<div class="cr-customer-bank-account-overview w-full max-w-full">

    @if (!initialized) {

        <p-skeleton height="16rem"></p-skeleton>

    } @else if (!baseDataWidget || !billingAccountsWidget) {

        <p-message severity="info"
                   text="Keine Bankverbindung ausgewählt."
                   styleClass="w-full">
        </p-message>

    } @else {

        <div class="flex flex-column gap-3">

            <mvs-widget [widgetData]="baseDataWidget"
                        [disableUpdate]="true">
            </mvs-widget>

            <div [class.overflow-x-auto]="compact">

                <mvs-widget [widgetData]="billingAccountsWidget"
                            [disableUpdate]="true"
                            (onObjectSelect)="handleBillingAccountSelect($event)">

                    <!-- Abrechnungskonto: name, else „Konto #id“; a closed account is marked, not hidden. -->
                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns"
                                 [fieldId]="columns.billingAccount.fieldId"
                                 [label]="columns.billingAccount.label">
                        <span class="text-sm">{{ accountLabel(object) }}</span>
                        @if (accountClosed(object)) {
                            <span class="text-sm text-500 ml-1">(geschlossen)</span>
                        }
                    </ng-template>

                    <!-- Zugeordnet bis: 31.12.9999 / no end = „unbefristet“ (E-7). -->
                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns"
                                 [fieldId]="columns.sliceEnd.fieldId"
                                 [label]="columns.sliceEnd.label">
                        <span class="text-sm white-space-nowrap">{{ endLabel(object) }}</span>
                    </ng-template>

                    <!-- Status: from the two dates against today (E-2), display only. -->
                    <ng-template let-object="object" mvs-widget-custom-field-directive
                                 area="columns"
                                 [fieldId]="columns.sliceState.fieldId"
                                 [label]="columns.sliceState.label">
                        @if (stateLabel(object); as stateText) {
                            <p-tag [value]="stateText"
                                   [styleClass]="stateStyleClass(object)">
                            </p-tag>
                        } @else {
                            <span class="text-sm">–</span>
                        }
                    </ng-template>

                </mvs-widget>

            </div>

        </div>

    }

</div>
